// extracted by mini-css-extract-plugin
export default {"container":"OrdersAndQuickTradeContainer_container__ed2Wo","topControls":"OrdersAndQuickTradeContainer_topControls__leWh+"};